module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Bulk"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer korn, halm, flis mm. i Walkingfloor trailer.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn er certificeret til fodertransport.\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/pp_fodertransport_certifikat.pdf",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "src": "/static/images/bulk_1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "product-image",
    staticStyle: {
      "width": "calc(50% - 10px)",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/bulk_2.jpg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d26c5764"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products/bulk.vue
// module id = 278
// module chunks = 1